import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PropositionInterfaceType, ReferenceDataService } from 'rome-library';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConfigurationDto } from '../models/configuration-dto.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private readonly masterReferenceDataKey = 'Master';
  private readonly referenceDataCache: {
    [propositionType: string]: {
      [interfaceType: string]: ConfigurationDto;
    };
  } = {};

  constructor(private readonly httpClient: HttpClient, private readonly referenceDataService: ReferenceDataService) {}

  getConfiguration(): Observable<any> {
    return this.httpClient.get('/configuration/referenceData');
  }

  public async loadDefaultApplicationConfiguration(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.referenceDataCache[this.masterReferenceDataKey]) {
        this.referenceDataService.referenceData =
          this.referenceDataCache[this.masterReferenceDataKey][this.masterReferenceDataKey];
        resolve(true);
      } else {
        this.getConfiguration().subscribe(
          (response) => {
            this.referenceDataCache[this.masterReferenceDataKey] = {};
            this.referenceDataCache[this.masterReferenceDataKey][this.masterReferenceDataKey] = response;

            this.referenceDataService.referenceData = response;
            resolve(true);
          },
          (error) => {
            console.error('Reference-Data could not be read');
            resolve(true);

            return throwError(error.json().error || 'Server error');
          }
        );
      }
    });
  }

  public loadConfigurationByPropositionInterfaceType(
    propositionInterfaceType: PropositionInterfaceType
  ): Observable<boolean> {
    if (this.isReferenceDataCached(propositionInterfaceType)) {
      this.referenceDataService.referenceData =
        this.referenceDataCache[propositionInterfaceType.PropositionId][propositionInterfaceType.InterfaceTypeId];

      return of(true);
    }

    return this.httpClient
      .put<ConfigurationDto>('/Configuration/ReferenceDataByPropositionInterfaceType', propositionInterfaceType)
      .pipe(
        tap((response) => {
          this.setReferenceDataForPropositionInterfaceType(response, propositionInterfaceType);
        }),
        map(() => {
          return true;
        }),
        catchError((error) => {
          console.log(error.json().error);

          return of(false);
        })
      );
  }

  private setReferenceDataForPropositionInterfaceType(
    configuration: ConfigurationDto,
    propositionInterfaceType: PropositionInterfaceType
  ): void {
    this.referenceDataCache[propositionInterfaceType.PropositionId] =
      this.referenceDataCache[propositionInterfaceType.PropositionId] || {};
    this.referenceDataCache[propositionInterfaceType.PropositionId][propositionInterfaceType.InterfaceTypeId] =
      configuration;

    this.referenceDataService.referenceData = configuration;
  }

  private isReferenceDataCached(propositionInterfaceType: PropositionInterfaceType): boolean {
    return (
      !!this.referenceDataCache[propositionInterfaceType.PropositionId] &&
      !!this.referenceDataCache[propositionInterfaceType.PropositionId][propositionInterfaceType.InterfaceTypeId]
    );
  }
}
